/** Number of sub-points sampled along the original surface for refinement. */
export const ORIGINAL_SURFACE_SUB_POINT_COUNT = 5;

/** Number of sub-points sampled along the adjacent surface for refinement. */
export const ADJACENT_SURFACE_SUB_POINT_COUNT = 10;

/** Divisor applied to ray distance to compute the ray origin offset. */
export const RAY_ORIGIN_OFFSET_DIVISOR = 50;

/** Scale factor applied to ray distance to compute the far endpoint. */
export const RAY_ENDPOINT_SCALE = 20;

/** Total vertex count for a BabylonJS box mesh (6 faces x 4 vertices). */
export const BOX_TOTAL_VERTEX_COUNT = 24;

/** Number of vertices per face on a BabylonJS box mesh. */
export const BOX_VERTICES_PER_FACE = 4;
